function OnlyAdmin({ scope, element }) {
  return (scope === 'admin' ? element : null)
}

export default OnlyAdmin;
